import { Col, Divider, Row } from "antd";
import { pageHeaderColor } from "../../utils/functions";
import { useCurrentUserContext } from "../../context/currentUserContext";

export const PageHeader = ({ title }) => {
    const { currentUser } = useCurrentUserContext();

    return (
        <Row gutter={{ lg: 24 }}>
            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                {/* <div className="pageHeader">{title}</div> */}
                <Divider className={`${pageHeaderColor(currentUser.lastSelectedCategoryCode) + " pageHeader"}`} orientation="left">{title}</Divider>
            </Col>
        </Row>
    )
}